<template>
  <div class="user-info container">
    <div class="user-info-inner">
      <div class="user-info-text">
        <p><img src="@/assets/icon/pass.png" alt="" /> Нэвтрэх нууц үг солих</p>
      </div>
      <div class="user-info-board">
        <form
          action=""
          class="user-edit-panel-profile-mobile"
          @submit.prevent="changePassword"
        >
          <div class="form-group flex column">
            <label for="">Хуучин нууц үг: </label>
            <div class="user-input">
              <input type="password" class="form-control" v-model="oPassword" />
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">шИНЭ НУУЦ ҮГ: </label>
            <div class="user-input">
              <input type="password" class="form-control" v-model="nPassword" />
            </div>
          </div>
          <div class="form-group flex column">
            <label for="">шИНЭ НУУЦ ҮГ давтах: </label>
            <div class="user-input">
              <input type="password" class="form-control" v-model="rPassword" />
            </div>
          </div>
          <div class="reset-password-error form-group">
            <div class="reset-password-error-inner" v-if="errorBox">
              <div class="password-error-icon">
                <img src="@/assets/icon/danger.png" alt="" />
              </div>
              <div class="password-error-msg">
                {{ errorBoxMessage }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <input type="submit" class="btn user-btn" value="Хадгалах" />
          </div>
        </form>
      </div>
    </div>
    <transition name="fade">
      <Error
        :errorMessage="errorMessage"
        v-if="errorModal"
        @hideErrorMessage="hideErrorMessage"
      ></Error>
    </transition>
    <transition name="fade">
      <Success
        :successMessage="successMessage"
        v-if="successModal"
        @hideSuccessMessage="hideSuccessMessage"
      ></Success>
    </transition>
  </div>
</template>

<script>
import Error from "@/views/plugin/error";
import Success from "@/views/plugin/success";
import EventBus from "@/EventBus.js";
export default {
  data() {
    return {
      oPassword: "",
      nPassword: "",
      rPassword: "",
      errorBox: false,
      errorBoxMessage: "",
      errorMessage: "",
      successMessage: "",
      errorModal: false,
      successModal: false,
    };
  },
  methods: {
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    changePassword() {
      var newPassword = this.nPassword;
      var rPassword = this.rPassword;
      var oldPassword = this.oPassword;
      if (newPassword.length >= 8) {
        if (newPassword === rPassword) {
          var tokenId = localStorage.getItem("authToken");
          var user = this.$auth.getMe();
          //lowercase,uppercase,digits,special digits
          let isCheckPassword =
            /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,25}$/.test(
              newPassword
            );
          if (isCheckPassword) {
            if (tokenId == null || user == null) {
              this.RedirectLogin();
              this.$auth.destroyToken();
              this.$auth.removeMe();
              this.$router.push({ name: "login" });
            }
            var cardHolderInfId = user.cardHolderInfId;
            this.$axiosApi
              .post(`system/forgotpassword/changepassword`, {
                tokenId,
                cardHolderInfId,
                oldPassword,
                newPassword,
              })
              .then((response) => {
                if (response.data.status === 0) {
                  this.oPassword = "";
                  this.nPassword = "";
                  this.rPassword = "";
                  this.successMessage = response.data.message;
                  this.successModal = true;
                  this.errorBox = false;
                }
              })
              .catch((error) => {
                this.RedirectLogin();
                this.$auth.destroyToken();
                this.$auth.removeMe();
                this.$router.push({ name: "login" });
              });
          } else {
            this.errorBoxMessage =
              "Таны оруулсан нууц үг том, жижиг үсэг, тоо, тусгай тэмдэгт /!@#$%^&*/ агуулсан байна!";
            this.errorBox = true;
          }
        } else {
          this.errorBoxMessage =
            "Таны шинэ нууц үг болон давтан бичсэн нууц үг хоорондоо таарахгүй байна ?";
          this.errorBox = true;
        }
      } else {
        this.errorBoxMessage =
          "Та хамгийн багадаа 8 оронтой нууц үг оруулна уу.";
        this.errorBox = true;
      }
    },
  },
  created() {
    this.hideMenu();
  },
  components: {
    Error,
    Success,
  },
};
</script>

<style scoped></style>
